/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import $ from 'jquery';
import _ from 'underscore';
import { crossPageSelectHeadRow } from '@bingads-webui/projection-grid-cross-page-select-all';
import { getGridName } from '@bingads-webui-campaign/inline-download-grids-metadata';
import { sortableHeaderTemplate, validateOrder } from '@bingads-webui-campaign/summary-grid-helper';
import preferenceService from '@bingads-webui-component-legacy/preference/service/index';
import config from '@bingads-webui-component-legacy/config/index';
import { getColumnsConfig } from '../columns/index';
import { getPluginsConfig } from './plugin-config';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/campaigns-tab/campaigns');
const schemaI18n = window.globalLegacyI18n.get('$/schema-i18n!campaign');

export function getConfig({
  dataSource,
  scope,
  view,
  filterService,
  addDateChangeListener,
  customHeaderOffset,
  isForVNext,
  viewport,
  isDataFetchManagerSource = false,
  gridName = getGridName('Campaign'),
  preferenceConfig,
  getCampaignTypeGlobalFilter,
}) {
  const tableName = i18n.getString('EntityType_Campaign_Plural');
  const permissions = config.get('Permissions');
  const { dynamic = {} } = permissions;

  const enableGridFlexLayout = _.result(dynamic, 'GridFlexLayout', false) && isForVNext && (gridName === getGridName('Campaign'));
  const scrolling = {
    header: {
      type: 'sticky',
      offset: customHeaderOffset || (() => $('nav.navbar-default.navbar-fixed-top').height()),
      attributes: {
        'aria-label': i18n.getString('{{tableName}} table header', { tableName }),
        role: 'rowgroup',
      },
    },
    virtualized: true,
  };

  const columns = getColumnsConfig({
    i18n,
    schemaI18n,
    scope,
    view,
    isForVNext,
    enableGridFlexLayout,
    getCampaignTypeGlobalFilter,
  });

  validateOrder(preferenceConfig, columns, gridName, permissions);

  if (viewport) {
    scrolling.viewport = viewport;
  }

  return {
    name: gridName,
    legacyGridName: 'CampaignsGrid',
    tableClasses: enableGridFlexLayout ? ['table'] : ['table', 'table-bordered'],
    tableAttributes: { 'aria-label': tableName },
    dataSource,
    selection: true,
    filterService,
    rows: {
      headRows:
        isForVNext
          ? [
            'column-header-rows',
          ]
          : [
            crossPageSelectHeadRow(),
            'column-header-rows',
          ],
    },
    columns,
    scrolling,
    plugins: getPluginsConfig({
      view,
      scope,
      addDateChangeListener,
    }),
    i18n,
    sortableHeader: {
      template: sortableHeaderTemplate,
    },
    preferenceService,
    config,
    isDataFetchManagerSource,
    ...enableGridFlexLayout && { layout: 'flex' },
  };
}
